// extracted by mini-css-extract-plugin
module.exports = {"wave2TeaserPC":"teaser_wave2TeaserPC__wFvyM"};